import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class LanguageService {
  public languages: string[] = ["en", "es", "de", "fr"];

  constructor(public translate: TranslateService) {
    let browserLang;
    this.translate.addLangs(this.languages);

    if (localStorage.getItem("language")) {
      browserLang = localStorage.getItem("language");
    } else {
      browserLang = "en";
      localStorage.setItem("language", "en");
    }
    translate.use(browserLang);
  }

  public setLanguage(lang) {
    this.translate.use(lang);
  }

  public getActiveLanguage() {
  return localStorage.getItem("language");
}
}
